<app-add-vehiculo
  [esEdicion]="true"
  [vehiculo]="vehiculoParaEditar"
></app-add-vehiculo>
